import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { ChevronRightIcon } from '@heroicons/react/24/outline'
import Loader from '../components/Loader'
import NieZnaleziono from './NieZnaleziono'

// Strona pary falownik + magazyn (/kompatybilnosc/<para>).
//
// Treść składa backend (backend_api/seo_compat.py) z reguł zgodności i wstrzykuje ją do #root.
// Bez tej trasy React zastępował ją stroną 404 z `noindex`, więc wszystkie strony par
// (ok. 250) Google po wykonaniu JS widział jako nieistniejące (wykryte 2026-10-13).
// Tu pokazujemy tę samą treść w układzie serwisu: przy wejściu z zewnątrz bierzemy HTML
// zapamiętany w index.js przed startem Reacta, przy przejściu wewnątrz aplikacji pobieramy stronę.

const zSerwera = (sciezka) => {
  const t = window.__VV_TRESC_SERWERA__
  return t && t.sciezka === sciezka && t.html.trim() ? t.html : null
}

// HTML pochodzi z naszego backendu (wartości escapowane w seo_compat), mimo to usuwamy
// wszystko, co mogłoby wykonać kod.
const wytnijTresc = (html) => {
  const doc = new DOMParser().parseFromString(html, 'text/html')
  const root = doc.getElementById('root')
  if (!root || !root.querySelector('h1')) return null
  root.querySelectorAll('script, style, iframe, object, embed').forEach((e) => e.remove())
  return { html: root.innerHTML, tytul: doc.title }
}

const KompatybilnoscPara = () => {
  const { slug } = useParams()
  const sciezka = window.location.pathname
  const [stan, setStan] = useState(() => {
    const html = zSerwera(sciezka)
    return html ? { html, blad: false } : { html: null, blad: false }
  })

  useEffect(() => {
    window.scrollTo(0, 0)
    const html = zSerwera(window.location.pathname)
    if (html) { setStan({ html, blad: false }); return undefined }
    let anulowane = false
    setStan({ html: null, blad: false })
    fetch(window.location.pathname)
      .then((r) => { if (!r.ok) throw new Error(String(r.status)); return r.text() })
      .then((tekst) => {
        if (anulowane) return
        const tresc = wytnijTresc(tekst)
        if (!tresc) throw new Error('brak treści')
        if (tresc.tytul) document.title = tresc.tytul
        setStan({ html: tresc.html, blad: false })
      })
      .catch(() => { if (!anulowane) setStan({ html: null, blad: true }) })
    return () => { anulowane = true }
  }, [slug])

  if (stan.blad) return <NieZnaleziono />
  if (!stan.html) {
    return <div className="flex justify-center py-24"><Loader /></div>
  }

  return (
    <div className="mx-auto max-w-[860px] px-4 sm:px-6 mt-6 mb-16">
      <div
        className={[
          'text-gray-700 leading-7',
          '[&_nav]:text-sm [&_nav]:text-gray-400 [&_nav]:mb-5 [&_nav_a:hover]:text-blue-600',
          '[&_h1]:text-2xl sm:[&_h1]:text-3xl [&_h1]:font-bold [&_h1]:text-gray-900 [&_h1]:leading-tight [&_h1]:mb-4',
          '[&_h2]:text-lg [&_h2]:font-bold [&_h2]:text-gray-900 [&_h2]:mt-8 [&_h2]:mb-3',
          '[&_p]:my-3 [&_ul]:list-disc [&_ul]:pl-5 [&_li]:my-1',
          '[&_table]:w-full [&_table]:text-sm [&_table]:my-4 [&_th]:text-left [&_th]:font-medium',
          '[&_th]:text-gray-500 [&_th]:py-2 [&_th]:pr-4 [&_td]:py-2 [&_tr]:border-b [&_tr]:border-gray-100',
          '[&_a]:text-blue-600 [&_a:hover]:underline',
        ].join(' ')}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: stan.html }}
      />
      <p className="mt-10 text-sm text-gray-600">
        Masz konkretne modele?{' '}
        <Link to="/kompatybilnosc" className="inline-flex items-center gap-1 font-semibold text-blue-600 hover:underline">
          Sprawdź je w wyszukiwarce zgodności <ChevronRightIcon className="w-4 h-4" />
        </Link>
      </p>
    </div>
  )
}

export default KompatybilnoscPara
